<template>

    <div style="width:50rem;">
    <div class="flex justify-between content-center">

     <div class="mt-3 ml-3">
          <el-input size="small" v-model="keywords" placeholder="输入提货码|单号" style="width:15rem;" maxlength="30" clearable /> <el-button  color="#626aef" plain @click="searchKeywordsFun" size="small" >查询</el-button>
     </div>

     <div class="mt-3">
        <el-pagination sm layout="prev, pager, next"
            :page-size="pageSize" :current-page="currentPage" :total="total" v-if="total>0" @current-change="directPage"
            > </el-pagination>

     </div>
    </div>

          <div  style="height:20rem;" class="mt-2">

<el-empty description="记录列表为空" v-if="recordList.length==0"></el-empty>

       <template v-for="(record,idx) in recordList" >

        <template v-if="chkIdx(idx)">

        <div class="ml-3 border-2 w-80 pl-1 pr-1 pt-1 pb-10 float-left mr-2 mb-2  relative">
            <div class="text-center text-lg" v-if="record.pickup!=undefined">{{record.pickup.accessCode}}</div>
            <div class="m-2 text-sm">
                <span class=" text-gray-400">单号</span>
                <span class="pl-1">{{record.orderID}}</span>
            </div>
            <div class="m-2 text-sm">
                <span class=" text-gray-400">时间</span>
                <span  class="pl-1">{{record.createTime}}</span>
            </div>
              <div class="m-2 text-sm">
                <span class=" text-gray-400">总金额</span>
                <span  class="pl-1">{{record.totalAmount}}</span>
            </div>
             <div class="m-2 text-sm">
                <span class=" text-gray-400">总数量</span>
                <span  class="pl-1">{{record.totalQuantity}}</span>
            </div>
            <div class="m-2 text-sm" v-if="record.pickup!=undefined">
                <span class=" text-gray-400">手机号</span>
                <span  class="pl-1" >{{record.pickup.mobile}}</span>
            </div>
            <div class="m-2 text-sm" v-if="record.pickup!=undefined">
                <span class=" text-gray-400">预约时间</span>
                <span  class="pl-1" >{{record.pickup.pickupDate}} {{record.pickup.pickupTime}}</span>
            </div>
            <div class="m-2 text-sm" >
                <span class=" text-gray-400">订单类型</span>
                <span  class="pl-1  text-green-400 text-lg font-bold" v-if="record.paymentCls==2">到店付款</span>
                <span  class="pl-1 text-green-400 text-lg font-bold" v-if="record.paymentCls==1">自提订单</span>
            </div>
            <div class="m-2 text-sm" >
                <span class=" text-gray-400">订单状态</span>
                <span  class="pl-1 text-yellow-600 text-lg font-bold" v-if="record.stateID==1">待付款</span>
                <span  class="pl-1 text-yellow-600 text-lg font-bold" v-if="record.stateID==31">待提货</span>
                <span  class="pl-1 text-yellow-600 text-lg font-bold" v-if="record.stateID==32">已提货</span>
                <span  class="pl-1 text-yellow-600 text-lg font-bold" v-if="record.stateID==2">已付款</span>
                <span  class="pl-1 text-yellow-600 text-lg font-bold" v-if="record.stateID==9">已完成</span>

                <span  class="pl-1 text-yellow-600 text-lg font-bold" v-if="record.stateID==41">待发货</span>
                <span  class="pl-1 text-yellow-600 text-lg font-bold" v-if="record.stateID==42">已发货</span>
                <span  class="pl-1 text-yellow-600 text-lg font-bold" v-if="record.stateID==43">确认收货</span>
            </div>
            <div class="m-2 text-sm h-52  overflow-y-auto">
                <template v-for="(goods,cidx) in record.orderItemList">
                    <p>
                    <span>{{goods.goodsName}}*</span><span class="text-red-400 font-semibold text-lg">{{goods.totalQuantity}}{{goods.unitName}}</span>
                    </p>       
                </template>
            </div>    

              <div class="flex items-center justify-between px-5  absolute bottom-2 w-full text-lg">

                  <div class=" cursor-pointer text-yellow-700"  @click="doFinishFun(record.orderID,'发货完成')"  v-if="record.stateID==31">
                       <i class="iconfont icon-tijiao"></i>
                       <span  class="pl-1">确认发货</span>
                   </div>

                   <div class=" cursor-pointer text-yellow-700"  @click="doFinishFun(record.orderID,'付款完成')" v-if="record.stateID==1 && record.paymentCls==2 " >
                       <i class="iconfont icon-tijiao"></i>
                       <span  class="pl-1">付款完成</span>
                   </div>
              </div>

        </div>

      </template>

        </template>

          </div>
  </div>
</template>
<script>
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getOrderList,finishOrder } from '@/utils/pickup.js'

export default {
name: 'OrderPickup',
setup () {
  const keywords = ref('')
  const recordList = ref([])

  const pageSize = ref(2)
    const currentPage = ref(1)
    const total = ref(0)
    const directPage = (idx) => {
      currentPage.value=idx;
    }
  const searchFun = () => {
    recordList.value=[];
    getOrderList({
        keywords:keywords.value.replace(/\s+/g, ''),
        offset: 1,
        limit: 20
    }, (res) => {
        console.log(res);
        total.value = res.total;
        recordList.value = res.items
    })
  }
  const searchKeywordsFun = () => {
    searchFun()
  }


  const doFinishFun = (billID,remark) => {
    ElMessageBox.confirm(
      '是否确定订单' + billID + remark+'?',
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }
    ).then(() => {
        finishOrder({
            remark:'',
        orderID: billID
      }, () => {
        ElMessage({
          showClose: true,
          message: '操作完成',
          type: 'success'
        })
        setTimeout(() => {
          searchKeywordsFun()
        }, 1000)
      })
    })
  }

  const chkIdx = (idx)=>{
    let s=(currentPage.value-1)*pageSize.value;
    let e = currentPage.value*pageSize.value;

    if(idx>=s && idx<e){
      return true;
    }

    return false;
  }



  return {
    recordList,
    pageSize,
      total,
      currentPage,
      directPage,
    searchFun,
    searchKeywordsFun,
    keywords,
    doFinishFun,
    chkIdx
  }
}
}
</script>
<style scoped>

</style>
